import { FC } from "react";
import { Form } from "react-bootstrap";
import { useSearch } from "./useSearch";

interface SearchBarProps {
  className?: string;
  items: any[];
  handleResult: any;
  filter: number;
  inputText: string;
}

const SearchBar: FC<SearchBarProps> = ({
  className,
  items,
  handleResult,
  filter,
  inputText,
}) => {
  const { onInputChange } = useSearch(items, handleResult, filter);

  return (
    <div className={className}>
      <Form.Control
        type="text"
        placeholder={inputText}
        onChange={(e) => onInputChange(e)}
      />
    </div>
  );
};

export default SearchBar;
